import React, { useState } from "react";
import { Inertia } from "@inertiajs/inertia";
import { Container } from "@/Components";
import { LabeledInput } from "@/Components/Form";

function TwoFactorChallenge({ errors }) {
  const [code, setCode] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const submitCode = (e) => {
    e.preventDefault();
    setIsLoading(true);
    Inertia.post(
      "/two-factor-challenge",
      { code },
      {
        onFinish: () => setIsLoading(false),
      },
    );
  };

  return (
    <Container size="max-w-2xl bg-white self-center md:dots-topright md:dots-bottomleft overflow-visible relative p-4 md:p-16 md:mt-10">
      <div className="flex flex-col items-start">
        <a href="/">
          <img
            className="mb-8 h-16 w-16 self-start"
            src="/images/logo_dark.png"
            alt="Gidås logo"
          />
        </a>
        <h2 className="mb-2 text-2xl font-bold">
          Enter the code from your authenticator app
        </h2>
      </div>
      <div className="mt-8">
        <form onSubmit={submitCode} aria-live="polite">
          <LabeledInput
            required
            type="text"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            title="Code"
            error={errors.code}
            aria-invalid={!!errors.code}
            aria-describedby="code-error"
          />

          <div className="mt-8 flex justify-end">
            <button className="btn-blue grow-0" disabled={isLoading}>
              {isLoading ? "Submitting..." : "Continue"}
            </button>
          </div>
        </form>
      </div>
    </Container>
  );
}

export default TwoFactorChallenge;
